import { render, staticRenderFns } from "./ImportPolonDictionaries.vue?vue&type=template&id=64559ec8&scoped=true&"
import script from "./ImportPolonDictionaries.vue?vue&type=script&lang=js&"
export * from "./ImportPolonDictionaries.vue?vue&type=script&lang=js&"
import style0 from "./ImportPolonDictionaries.vue?vue&type=style&index=0&id=64559ec8&scoped=true&lang=scss&"
import style1 from "./ImportPolonDictionaries.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64559ec8",
  null
  
)

export default component.exports